module.exports = __webpack_public_path__ + "static/media/mini-andarbahar.ea141601.png";